import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const SearchBar = ({ initial = "", size = "lg", autoFocus = false }) => {
  const [value, setValue] = useState(initial);
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/recherche?q=${encodeURIComponent(q)}`);
  };

  const big = size === "lg";

  return (
    <form onSubmit={submit} data-testid="search-form" className="w-full">
      <div
        className={`flex items-stretch overflow-hidden rounded-lg border-2 border-border bg-[hsl(var(--surface))] transition-colors focus-within:border-[hsl(var(--brand))] ${
          big ? "shadow-[0_1px_0_0_rgba(0,0,0,0.02)]" : ""
        }`}
      >
        <div className="flex items-center pl-4 text-[hsl(var(--fg-muted))]">
          <Search className={big ? "h-5 w-5" : "h-4 w-4"} />
        </div>
        <input
          data-testid="search-input"
          type="text"
          value={value}
          autoFocus={autoFocus}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Nom d'entreprise, SIREN, SIRET ou RCS"
          aria-label="Rechercher une entreprise"
          className={`w-full bg-transparent text-[hsl(var(--fg-primary))] placeholder:text-[hsl(var(--fg-muted))] focus:outline-none ${
            big ? "px-3 py-4 text-lg" : "px-3 py-2.5 text-base"
          }`}
        />
        <button
          data-testid="search-submit"
          type="submit"
          className={`shrink-0 bg-[hsl(var(--brand))] font-medium text-white transition-colors hover:bg-[hsl(var(--brand-hover))] ${
            big ? "px-7 text-base" : "px-5 text-sm"
          }`}
        >
          Rechercher
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
